(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sg1291-quantity-tiers"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sg-quantity-tiers')) {
    class SgQuantityTiers extends HTMLElement {
      connectedCallback() {
        this._onChange = this._onChange.bind(this);
        this.addEventListener('change', this._onChange);
      }
      disconnectedCallback() {
        this.removeEventListener('change', this._onChange);
      }
      _scope() {
        return this.closest('.shopify-section') || document;
      }
      _quantityInputs() {
        return this._scope().querySelectorAll('product-form-component input[name="quantity"]');
      }
      _onChange(event) {
        const radio = event.target;
        if (!radio || radio.type !== 'radio') return;
        const qty = parseInt(radio.getAttribute('data-qty'), 10);
        if (!qty || qty < 1) return;
        this._quantityInputs().forEach((input) => {
          input.value = qty;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
        const stickyNumber = this._scope().querySelector('sticky-add-to-cart [ref="quantityNumber"]');
        if (stickyNumber) stickyNumber.textContent = String(qty);
        const stickyDisplay = this._scope().querySelector('sticky-add-to-cart [ref="quantityDisplay"]');
        if (stickyDisplay && qty > 1) stickyDisplay.hidden = false;
      }
    }
    customElements.define('sg-quantity-tiers', SgQuantityTiers);
  }
  } catch(e) { console.error(e); }
})();

})();
